/* components/ProductsFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionFilters extends ThemeComponent {
    @Ref()
    details!: HTMLDListElement[];

    init() {
        this.handleDetailsOpen(this.details);
    }

    private handleDetailsOpen(details: HTMLDListElement[]) {
        for (const detail of details) {
            detail.addEventListener("click", () => {
                for (const sibling of details) {
                    if (detail !== sibling) {
                        sibling.removeAttribute("open");
                    }
                }
            });

            const checkBoxes = detail.querySelectorAll('input[type="checkbox"') as NodeList;
            const selectHeader = detail.querySelector('[data-ref="headerSelected"]');

            let checkedBoxesCount = 0;
            for (const checkBox of checkBoxes) {
                const checkBoxItem = checkBox as HTMLInputElement;

                if (checkBoxItem.checked) {
                    checkedBoxesCount += 1;
                }
            }

            for (const checkBox of checkBoxes) {
                const checkBoxItem = checkBox as HTMLInputElement;

                this.$listen(checkBoxItem, 'click', (e) => {
                    if (checkBoxItem.checked) {
                        checkedBoxesCount += 1;
                    } else {
                        checkedBoxesCount -= 1;
                    }

                    if (selectHeader) {
                        selectHeader.innerHTML = `${checkedBoxesCount} selected`;
                    }
                });
            }
        }
    }
}
